/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HealthControllerDetailedQueryResponse, HealthControllerDetailed503 } from "../../models/healthController/HealthControllerDetailed";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { healthControllerDetailed } from "../../clients/healthService/healthControllerDetailed";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const healthControllerDetailedQueryKey = () => [{
  url: '/health/detailed'
}] as const;
export type HealthControllerDetailedQueryKey = ReturnType<typeof healthControllerDetailedQueryKey>;
export function healthControllerDetailedQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = healthControllerDetailedQueryKey();
  return queryOptions<HealthControllerDetailedQueryResponse, ResponseErrorConfig<HealthControllerDetailed503>, HealthControllerDetailedQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return healthControllerDetailed(config);
    }
  });
}

/**
 * @summary Detailed health check with database status
 * {@link /health/detailed}
 */
export function useHealthControllerDetailed<TData = HealthControllerDetailedQueryResponse, TQueryData = HealthControllerDetailedQueryResponse, TQueryKey extends QueryKey = HealthControllerDetailedQueryKey>(options: {
  query?: Partial<QueryObserverOptions<HealthControllerDetailedQueryResponse, ResponseErrorConfig<HealthControllerDetailed503>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? healthControllerDetailedQueryKey();
  const query = useQuery({
    ...healthControllerDetailedQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HealthControllerDetailed503>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}